export const frontEndTag = "Front-end";
export const backEndTag = "Back-end";
export const mobileTag = "Mobile";
export const dbTag = "Database";
export const langTag = "Language";
export const miscTag = "Misc";

export const skillSet = [
  {
    name: "React",
    img: "/react.svg",
    tags: [frontEndTag],
  },
  {
    name: "Vue",
    img: "/vue.png",
    tags: [frontEndTag],
  },
  {
    name: "Nest",
    img: "/nest.png",
    tags: [backEndTag],
  },
  {
    name: "Express",
    img: "/express.png",
    tags: [backEndTag],
  },
  {
    name: "Fastify",
    img: "/fastify.jpg",
    tags: [backEndTag],
  },
  {
    name: "Django",
    img: "/django.png",
    tags: [backEndTag],
  },
  {
    name: "ReactNative",
    img: "/reactnative.webp",
    tags: [mobileTag],
  },
  {
    name: "Flutter",
    img: "/flutter.png",
    tags: [mobileTag],
  },
  {
    name: "Docker",
    img: "/docker.png",
    tags: [miscTag],
  },
  {
    name: "Git",
    img: "/git.png",
    tags: [miscTag],
  },
  {
    name: "PostgreSQL",
    img: "/postgres.svg",
    tags: [dbTag, miscTag],
  },
  {
    name: "MySQL",
    img: "/mysql.png",
    tags: [dbTag, miscTag],
  },
  {
    name: "MongoDB",
    img: "/mongo.png",
    tags: [dbTag, miscTag],
  },
  {
    name: "Redis",
    img: "/redis.png",
    tags: [dbTag, miscTag],
  },
  {
    name: "Kdb+",
    img: "/kdb.png",
    tags: [dbTag, miscTag],
  },
  {
    name: "C",
    img: "/c.png",
    tags: [langTag],
  },
  {
    name: "C++",
    img: "/cpp.png",
    tags: [langTag],
  },
  {
    name: "Javascript",
    img: "/js.png",
    tags: [langTag],
  },
  {
    name: "Typescript",
    img: "/ts.svg",
    tags: [langTag],
  },
  {
    name: "Python",
    img: "/python.png",
    tags: [langTag],
  },
];
